// src/Util/routerHelper.js
export function crudRoutes(base, perm, components) {
    // components: { list: "Quality", add: "InputQuality", update: "UpdateQuality", details: "DetailsQuality" }
    const basePath = `/${base}`;

    const routes = [
        {
            path: `${basePath}`,
            exact: true,
            permission: `${perm}:view`,
            component: components.list,
        },
        {
            path: `${basePath}/add`,
            exact: true,
            permission: `${perm}:create`,
            component: components.add,
        },
        {
            path: `${basePath}/update/:id`,
            exact: true,
            permission: `${perm}:update`,
            component: components.update,
        },
    ];

    if (components.details) {
        routes.push({
            path: `${basePath}/details/:id`,
            exact: true,
            // Defaults to `${perm}:view`; pass components.detailsPermission to
            // gate the details page behind a dedicated permission instead.
            permission: components.detailsPermission || `${perm}:view`,
            component: components.details,
        });
    }

    return routes.filter(Boolean);
}
